class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      const sectionHtml = parsedState.sections?.[section.id];
      if (sectionElement && sectionHtml) {
        try {
          const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
          if (innerHtml !== null) sectionElement.innerHTML = innerHtml;
        } catch (e) {
          console.warn('Cart notification: Could not render section', section.id, e);
        }
      }
    });

    if (this.header) this.header.reveal();
    this.open();
    this.applyMinOrderValidation(parsedState);
  }

  applyMinOrderValidation(parsedState) {
    const settings = window.minOrderSettings;
    if (!settings || !settings.productIds || settings.productIds.length === 0) return;

    const checkoutButton = this.querySelector('#cart-notification-form button[name="checkout"]');
    if (!checkoutButton) return;

    // Remove any existing notice
    const existingNotice = this.querySelector('.cart-notification__min-order-notice');
    if (existingNotice) existingNotice.remove();

    // Use parsedState to check cart items (available as cart response)
    // Fetch current cart to validate
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        if (!cart.items || cart.items.length === 0) return;

        let totalQty = 0;
        let allInCollection = true;

        for (const item of cart.items) {
          if (settings.productIds.includes(item.product_id)) {
            totalQty += item.quantity;
          } else {
            allInCollection = false;
            break;
          }
        }

        if (allInCollection && totalQty < settings.minQuantity) {
          checkoutButton.disabled = true;

          const notice = document.createElement('p');
          notice.className = 'cart-notification__min-order-notice';
          notice.style.cssText = 'margin: 0.5rem 0 0; padding: 0; color:#856404; font-size:0.8em; text-align:center; line-height:1.2;';
          notice.textContent = settings.message;
          checkoutButton.closest('form').after(notice);
        } else {
          checkoutButton.disabled = false;
        }
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
